import React from "react";
import { Modal, Form, Button } from "antd";

export default function FormModal({
  title,
  open,
  onClose,
  onFinish,
  children,
  submitText = "Save",
  loading = false,
  width = 600,
  form: externalForm,
  cancelText = "Cancel",
  destroyOnHidden = true,
  initialValues,
  ...rest
}) {
  const [internalForm] = Form.useForm();
  const form = externalForm || internalForm;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden={destroyOnHidden}
      width={width}
      {...rest}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
      >
        {children}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            marginTop: "24px",
          }}
        >
          <Button
            onClick={onClose}
            style={{
              backgroundColor: "#D97A07",
              color: "#fff",
              border: "none",
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ backgroundColor: "#0D2E4D" }}
          >
            {submitText}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
